import Vue from 'vue'

/* eslint-disable */

if (process.env.NODE_ENV !== 'development') {
  (function (l, a, u, n, c, h, e, r) {
    l['HotmartLauncherObject'] = c;
    l[c] = l[c] || function () {
      (l[c].q = l[c].q || []).push(arguments)
    }, l[c].l = 1 * new Date();
    h = a.createElement(u),
    e = a.getElementsByTagName(u)[0];
    h.async = 1;
    h.src = n;
    e.parentNode.insertBefore(h, e)
  })(window, document, 'script', process.env.HOTMART_LAUNCHER, 'hot');

  window.hot('system', 'checkout-builder');
}

/* eslint-enable */

Vue.prototype.$hotLauncher = (l, a, u, n, c, h, e, r) => {
  if (process.env.NODE_ENV !== 'development' && window.hot) {
    window.hot(l, a, u, n, c, h, e, r)
  }
}

Vue.hotLauncher = Vue.prototype.$hotLauncher
